import React from 'react';
import { HOW_IT_WORKS } from '../mock';
import { CheckCircle2 } from 'lucide-react';

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="relative border-t border-[rgba(201,162,75,0.10)]">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-24">
        <div className="text-center max-w-3xl mx-auto">
          <p className="text-[10px] tracking-[0.25em] font-mono gold-text">HOW IT WORKS</p>
          <h2 className="font-display mt-5 text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-[1.05]">
            Structured Onboarding.
            <br />
            Controlled Automation.
          </h2>
          <p className="mt-6 text-[#CDBE94] leading-relaxed">
            From account creation to live automation — every step is designed with risk controls and transparency.
          </p>
        </div>

        <div className="mt-20 max-w-4xl mx-auto relative">
          {/* vertical line */}
          <div className="absolute left-[27px] md:left-[31px] top-2 bottom-2 w-px bg-gradient-to-b from-[#d8b34a]/40 via-white/10 to-transparent" />

          <div className="space-y-6">
            {HOW_IT_WORKS.map((step, idx) => (
              <div key={step.step} className="flex gap-6 fade-in-up" style={{ animationDelay: `${idx * 0.05}s` }}>
                <div className="relative shrink-0">
                  <div className="w-14 h-14 rounded-full border gold-border bg-[#0a0a0b] flex items-center justify-center">
                    <span className="font-mono text-xs gold-text">{step.step}</span>
                  </div>
                </div>
                <div className="flex-1 border border-white/[0.08] rounded-md p-6 md:p-8 bg-[#0c0c0e] hover:border-[#d8b34a]/30 transition-colors">
                  <h3 className="text-xl font-semibold text-white">{step.title}</h3>
                  <p className="mt-3 text-sm text-[#CDBE94] leading-relaxed">{step.description}</p>
                  <ul className="mt-5 space-y-2.5">
                    {step.points.map((p) => (
                      <li key={p} className="flex items-start gap-2.5 text-[13px] text-[#CDBE94]">
                        <CheckCircle2 size={14} className="mt-0.5 gold-text shrink-0" strokeWidth={1.8} />
                        <span>{p}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
